import React from 'react'

const Footer=()=> {
  return <footer>
    <div>
    <h1>TechyStar</h1>
    <p>@all right reserved</p>
    </div>
    <div>
      <h5>Follow us</h5>
      <div>
        <a href="http://" target={"blank"}>Youtube</a>
        <a href="http://" target={"blank"}>Instagram</a>
        <a href="http://" target={"blank"}>GitHub</a>
       
      </div>
    </div>
  </footer>
}

export default Footer